module.exports = __webpack_public_path__ + "static/media/angle-double-down-solid.83f0e0f0.svg";